<template>
    <div>
        <v-search>
            <router-link :to="{path:'add'}" class="f-right">
                <a-button type="primary" class="fr opbuttonmt">新增</a-button>
            </router-link>条件筛选
        </v-search>
        <v-tablelist></v-tablelist>
    </div>
</template>

<script>
import TableList from "./tablelist.vue";
import Search from "./search.vue";

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {},
    components: {
        "v-tablelist": TableList,
        "v-search": Search
    },
    mounted() {}
};
</script>

<style scoped>
</style>